import _ from '@lodash';
import { withRouter } from 'react-router-dom';
import ListView from './listView';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

function EndUsersAccountsTable(props) {
	if (!props.viewServiceRequestPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Service Requests at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			<SwitchView
				viewServiceRequestPermission = {props.viewServiceRequestPermission}
				createServiceRequestPermission = {props.createServiceRequestPermission}
				updateServiceRequestPermission = {props.updateServiceRequestPermission}
				deleteServiceRequestPermission = {props.deleteServiceRequestPermission}
			/>
		</div>
	);

}

function SwitchView({
	viewServiceRequestPermission, createServiceRequestPermission,
	updateServiceRequestPermission, deleteServiceRequestPermission
}) {
	return(
		<ListView
			viewServiceRequestPermission = {viewServiceRequestPermission}
			createServiceRequestPermission = {createServiceRequestPermission}
			updateServiceRequestPermission = {updateServiceRequestPermission}
			deleteServiceRequestPermission = {deleteServiceRequestPermission}
		/>
	)
}

export default withRouter(EndUsersAccountsTable)
